import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { WeeklyVisitor } from "../../../Constant";
import ReactApexChart from "react-apexcharts";
import { WEEKLY_VISITOR_OPTION } from "../../../Data/Dashboard";

const WeeklyVisitors = () => {
  return (
    <Col xl="3" md="6" sm="12" className="box-col-4e">
      <Card>
        <CardHeader className="card-no-border">
          <div className="header-top">
            <H3>{WeeklyVisitor} </H3>
          </div>
        </CardHeader>
        <CardBody className="py-0">
          <div id="weekly-visitors">
            <ReactApexChart type="radar" options={WEEKLY_VISITOR_OPTION} series={WEEKLY_VISITOR_OPTION.series} height={300}/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default WeeklyVisitors;
